module.exports = __webpack_public_path__ + "static/media/sidebar-2.c80de873.png";